module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/calendar.ad051f2c.svg";